import * as Sentry from '@sentry/vue'
import { createHead } from '@vueuse/head'
import { createApp } from 'vue'
import i18nPlugin from '@/compositions/i18nPlugin'
import { redactBreadcrumb, redactSentryEvent } from '@/compositions/sentryRedact'
import routerInitPlugin from '@/router/routerInitPlugin'
import App from './App.vue'
import appUtilsPlugin from './plugins/appUtilsPlugin'
import axiosPlugin from './plugins/axiosPlugin'
import elPlusPlugin from './plugins/elPlusPlugin'
import globalComponents from './plugins/globalComponents'
import piniaPlugin from './plugins/piniaPlugin'
import './css/index.css'

const head = createHead()
const Vue = createApp(App)
Vue.use(routerInitPlugin)
Vue.use(i18nPlugin)
if (!import.meta.env.SSR
  && window?.location?.hostname
  && window?.location?.hostname !== 'localhost') {
  const isPWA = window?.matchMedia?.('(display-mode: standalone)')?.matches || false
  Sentry.init({
    Vue,
    dsn: 'https://fb28a45677adf47cd8e82c5e009abc69@o48349.ingest.us.sentry.io/4508211576963072',
    beforeSend(event) {
      event.tags = {
        ...event.tags,
        isPWA: isPWA ? 'yes' : 'no'
      }
      return redactSentryEvent(event)
    },
    // breadcrumbs are redacted when recorded (and again in beforeSend): xhr/fetch URLs, navigation from/to, console args
    beforeBreadcrumb: breadcrumb => redactBreadcrumb(breadcrumb),
    // SDK v11 collects user info, cookies, headers, bodies, query params and frame variables by default -
    // keep the restrictive v10 behaviour (no PII; tokens live in query params and request bodies).
    // Only User-Agent is kept: Sentry derives browser/os/device from it (Referer is not sent - it can carry a URL with tokens)
    dataCollection: {
      userInfo: false,
      cookies: false,
      httpHeaders: { request: { allow: ['User-Agent'] }, response: false },
      httpBodies: [],
      urlQueryParams: false,
      stackFrameVariables: false
    },
    integrations: [
      // Sentry.browserTracingIntegration({ router }),
      // Sentry.replayIntegration()
    ],
    environment: import.meta.env.VITE_PROD === 'on' ? 'production' : 'development',
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    // tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],
    // Session Replay
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0
  })
}
Vue.use(head)
Vue.use(piniaPlugin)
Vue.use(axiosPlugin)
Vue.use(elPlusPlugin)
Vue.use(appUtilsPlugin)
Vue.use(globalComponents)
Vue.mount('#app')
